// Variáveis correspondentes ao textos em inglês do site.
let btnCases = `View more`;
let menu = `Contact`
let footer = [`a company does:`, `Address:`, `Telephone:`, `Email:`, `Social:`, `languages:`];

const inicio = {
  page: [
    menu,
    `Transformative relationships<br> between people and brands`,
    `We plan and execute modern communication campaigns, managing your brand’s communities. Being them internal, external or loyal. If you are a collaborator or client and<br> share the values ​​of your brand:`,
    `Let's communicate, interact, let's create.`,
    `Digital Marketing <br> and Social Media`,
    `Incentive, Engagement <br> and internal relationship`,
    `Loyalty and empowerment <br> of relationships`,
    `Cases`,
    `Incentive & <strong>Engagement</strong>`,
    `Del Valle`,
    `Motivate, empower, engage the sales force to sell a product that is not the most attractive of the company's portfolio and have a campaign that competes...`,
    btnCases,
    `Incentive & <strong>Engagement</strong>`,
    `Mitsubishi`,
    `Mitsubishi is a solid brand with strong products that pass away from maintenance. This force has become a challenge: increasing consumption of after-sales products and services...`,
    btnCases,
    `Social <strong>Media</strong>`,
    `Pom Pom`,
    `Launch of Nova Protek, highlighting the technology ComfortFit 40% thinner without letting the diaper weigh and fall. In addition to having front flaps and elastic ears, allowing the ideal adjustment to the baby's body...`,
    btnCases,
    `Incentive & <strong>Engagement</strong>`,
    `Royal Canin`,
    `Create a strategy for launching the 48-hour program, providing stimulus to purchase Royal Canin products...`,
    btnCases,
    `Social <strong>Media</strong>`,
    `Skyn`,
    `To Be one of the most non-sponsoring brands during the most important sports games in the world that happened in Rio de Janeiro...`,
    btnCases,
    `Digital <strong>Solution</strong>`,
    `Samsung`,
    `Our team of technology and creation worked together in the development of a unique and modular methodology...`,
    btnCases,
    `talk to <strong>Digi</strong>`,
    `Name`,
    `Email`,
    `Telephone`,
    `Message`,
    `Cases`,
    footer[0],
    footer[1],
    footer[2],
    footer[3],
    footer[4],
    footer[5],
  ],
  pagePt: []
};

const delvalle = {
  case: [
    menu,
    `Del Valle <br>Safra de campeões`,
    `Challenge`,
    `Motivate, empower, engage the sales force to sell a product that is not the most the portfolio of the company and have a campaign that competes with the bold and aggressive brand campaigns. Of the most traditional drinks on the market.`,
    `Idea`,
    `Create a relationship program that values sellers of this product, brings team to the brand training and sales challenges that distribute premiums through points in a very diverse catalog. Also offer attractive final awards to keep the team committed and interested in throughout the year. We have created the Safra of champions.`,
    `Results`,
    `The platform was so successful that it was converted into a program for all products and distributors of the company. <br> <br> We empower all 5000  participants with more of 20 exclusive trainings and in a specially designed format for mobile access and short duration, with high content absorption. <br> <br> <br> We have awarded more than 4000 employees, out of 5000 participants, and we distribute many prizes. <br> In the end we get better every distributor made a fantastic trip.`,
    `Cases`,
    footer[0],
    footer[1],
    footer[2],
    footer[3],
    footer[4],
    footer[5],
  ],
  pagePt: []
};

const mitsubishi = {
  case: [
    menu,
    `Mitsubishi <br>Profissionais Diamante`,
    `Challenge`,
    `Mitsubishi is a solid brand with strong products that pass away from maintenance. <br> <br> This force has become a challenge: increasing the consumption of after-sales service.`,
    `Idea`,
    `As the quality of Mitsubishi comes from the inside out, we created the Professionals. Mitsubishi Diamond. <br> <br> Since diamond is the most resistant element of  nature, and when cut, even more its value, we have created a sales incentive with an online training and  qualification platform.`,
    `Results`,
    `Increase in sales of oils and fluids, accessories and  parts and original products M-Tech and MIT4Fun.`,
    `Cases`,
    footer[0],
    footer[1],
    footer[2],
    footer[3],
    footer[4],
    footer[5],
  ],
  pagePt: []
};

const pompom = {
  case: [
    menu,
    `Pom Pom <br>launch of the new Protek`,
    `Challenge`,
    `Launch of Nova Protek, emphasizing the technology  ComfortFit 40% thinner without leaving the diaper weigh and fall. Besides having front flaps and elastic ears, allowing the ideal adjustment to the body of the drink.`,
    `Idea`,
    `Devote to Sabrina Sato as the new mom Pom Pom. And with that, to divulge Nova Protek in his show, in addition to live show held at Facebook headquarters with Sabrina and her husband Duda Nagle. Showing all the details and news that the product has brought to its consumers in a very personal and engaging way. <br> <br> Digital actions were applied simultaneously in the main social networks (Facebook, Instagram and Youtube), besides with 15 microinfluencers. <br> <br> In offline media, we went out in the special edition of Joyce Pascowitch magazine and made diaper donations for the Sabrina Sato Institute. <br> <br> The high turnaround in engagement and reach of the social networks of the brand was surprising, reaching 33 million people. <br> <br> We also achieved over 8.6 million impressions through the Sabrina program, and more than 9,000 clicks per R7. <br> <br> Generation of more than 200 contents for the social networks of the brand. 8.6 Million prints through Sabrina's program. Conquest of spontaneous off-line media`,
    `Results`,
    `With microinfluencers we can reach more than one million people, with more than 200 content between posts and stories. <br> <br> The high turnaround in engagement and reach of the social networks of the brand was surprising, reaching 33 million people. <br> <br> We also achieved over 8.6 million impressions through the Sabrina program, and more than 9,000 clicks per R7.`,
    `Cases`,
    footer[0],
    footer[1],
    footer[2],
    footer[3],
    footer[4],
    footer[5],
  ],
  pagePt: []
};

const royal = {
  case: [
    menu,
    `Royal Canin<br>48horas`,
    `Challenge`,
    `Creating a strategy for the 48 hour program’s release, estimulating the purchase of the royal canin products. Making contact with owners / participants of the awarded crown program in the period of 48 hours, stimulating the purchase of royal canin products in up to 7 days. `,
    `Idea`,
    `Creating relationship, informing and promoting consumption of royal canin products through simple and direct channels, but certain. Serving royal with an online partner control platform and an active service desk that makes active links to customers in less than 48 hours after the purchase of a puppy from a royal canin partner breeder.`,
    `Results`,
    `a new experience of purchase and relationship that brings the dog owner closer to the royal canin brands. We show the benefits of royal logo at the beginning of the love between owner and animal, creating a brand life partnership with both.`,
    `Cases`,
    footer[0],
    footer[1],
    footer[2],
    footer[3],
    footer[4],
    footer[5],
  ],
  pagePt: []
};

const skyn = {
  case: [
    menu,
    `Skyn <br>Sinta o Rio`,
    `Challenge`,
    `Be one of the most non-sponsoring brands during sports games important events that took place in Rio de Janeiro in 2016.`,
    `Idea`,
    `We launched a photographic challenge for SKYN brandlovers: what is the best way to live and feel the host city of the games? That way, we encourage brand fans to post photos on their networks social with the hashtag #SintaoRio and so, promoting the concept of the campaign through a video, posts in networks social networks of SKYN and a hotsite. <br> <br> All participating images automatically uploaded to the action site, which also contained information tourist and all that Rio de Janeiro has of the most sensual. At the end of the campaign, we chose the photo that best represented the essence of Rio and we rewarded with a trip to the city with companion and everything included. <br> <br> To further pulverize the action, we have the participation of several digital influencers who told the followers of SKYN what the best way to feel Rio de Janeiro. Among them were Luke Lucco, Felipe Tito, Carol Diaz and Fernando Scherer. In addition, we also have the release of # profile @ verdadedesafio. <br> <br> Instagram has more than 120,000 followers and works with various challenges for its followers.`,
    `Results`,
    `#SintaoRio's site had 8.4 million impressions, and the campaign video over 500,000 views. There were more than 20 thousand photos published by brandlovers and almost 68 thousand comments in the publications of SKYN's website. As a balance, the action formed a memorable record about Rio de Janeiro and the atmosphere of the City.`,
    `Cases`,
    footer[0],
    footer[1],
    footer[2],
    footer[3],
    footer[4],
    footer[5],
  ],
  pagePt: []
};

const samsung = {
  case: [
    menu,
    `Samsung`,
    `Challenge`,
    `During the first semester of 2019, Samsung needed to exhibit a large series of releases to online retailers through its products landing pages. The goal was to provide these sale channels with rich content for announcement and sales argument.`,
    `Idea`,
    `Our technology and creativity team assisted in the development of an unique and modular methodology of pre-templates for each product line, which optimized the work and reduced the total production time. <br> <br> The pages were 100% developed in HTML5, CSS3, JavaScript and Jquery, including movement and use simulations, which increase the product value and the partner’s e-commerce.`,
    `Results`,
    `Within 6 months, approximately 25 special pages with content related to smartphones, laptops, augmented reality glasses, tablets, smartwatches and headphones were developed and announced to the main online retailers in Brazil. <br> <br> The objective was to make the products more attractive to consumers, facilitate the features’ release through search robots, increase product value and help showing that Samsung is on the leading edge of the technology segment.`,
    `Cases`,
    footer[0],
    footer[1],
    footer[2],
    footer[3],
    footer[4],
    footer[5],
  ],
  pagePt: []
};


// percorre a lista de itens e altera o texto conforme a sequência do objeto de arrays com os texto em inglês
function trocaIdioma() {
  const targetIdioma = $('[data-idioma="ingles"]');
  const paginaAtual = $('.conteudo').attr('class').split(' ')[1];
  const caseAtual = $('[data-page]').attr('data-page');

  $.each(targetIdioma, function (index, el) {

    if (paginaAtual === 'case-dell-vale' || caseAtual === 'case-dell-vale') {
      delvalle.pagePt.push(el.innerHTML);

      if($('html')[0].lang === 'en') {
        el.innerHTML = delvalle.case[index];
        const video = 'videos/en/del-valle.mp4',
          videoTag = $('[data-vid="video"]'),
          videoSrc = $('[data-vid="video"] source');
        videoSrc.attr('src', video);
        videoTag[0].load();
      } else if ($('html')[0].lang === 'pt') {
        el.innerHTML = delvalle.pagePt[index];        
        const video = 'videos/pt/del-valle.mp4',
          videoTag = $('[data-vid="video"]'),
          videoSrc = $('[data-vid="video"] source');
        videoSrc.attr('src', video);
        videoTag[0].load();
      }
    } else if (paginaAtual === 'case-mitsubishi' || caseAtual === 'case-mitsubishi') {
      mitsubishi.pagePt.push(el.innerHTML);    
      if($('html')[0].lang === 'en') {
        el.innerHTML = mitsubishi.case[index];
      } else if($('html')[0].lang === 'pt') {
        el.innerHTML = mitsubishi.pagePt[index];    
      }
    } else if (paginaAtual === 'case-pompom' || caseAtual === 'case-pompom') {
      pompom.pagePt.push(el.innerHTML);
      if($('html')[0].lang === 'en') {
        el.innerHTML = pompom.case[index];
      } else if($('html')[0].lang === 'pt') {
        el.innerHTML = pompom.pagePt[index];    
      }
    } else if (paginaAtual === 'case-royal-canin' || caseAtual === 'case-royal-canin') {
      royal.pagePt.push(el.innerHTML);
      if($('html')[0].lang === 'en') {
        el.innerHTML = royal.case[index];
      } else if($('html')[0].lang === 'pt') {
        el.innerHTML = royal.pagePt[index];    
      }
    } else if (paginaAtual === 'case-skyn' || caseAtual === 'case-skyn') {
      skyn.pagePt.push(el.innerHTML); 
      if($('html')[0].lang === 'en') {
        el.innerHTML = skyn.case[index];
      } else if($('html')[0].lang === 'pt') {
        el.innerHTML = skyn.pagePt[index];
      }
    } else if (paginaAtual === 'case-samsung' || caseAtual === 'case-samsung') {
      samsung.pagePt.push(el.innerHTML); 
      if($('html')[0].lang === 'en') {
        el.innerHTML = samsung.case[index];
      } else if($('html')[0].lang === 'pt') {
        el.innerHTML = samsung.pagePt[index];
      }
    } else if (paginaAtual === 'home') {       
      inicio.pagePt.push(el.innerHTML);
      if($('html')[0].lang === 'en') {
        el.innerHTML = inicio.page[index];
      } else if($('html')[0].lang === 'pt') {
        el.innerHTML = inicio.pagePt[index];
      }
    }
  });
}